__turbopack_context__.v({
  "footerActionButton": "account-drawer-module-scss-module__R3H9Uq__footerActionButton",
  "footerActionButtonIcon": "account-drawer-module-scss-module__R3H9Uq__footerActionButtonIcon",
  "infoIconButton": "account-drawer-module-scss-module__R3H9Uq__infoIconButton",
  "logoutWrap": "account-drawer-module-scss-module__R3H9Uq__logoutWrap",
  "panel": "account-drawer-module-scss-module__R3H9Uq__panel",
  "panelDivider": "account-drawer-module-scss-module__R3H9Uq__panelDivider",
  "panelRow": "account-drawer-module-scss-module__R3H9Uq__panelRow",
  "panelRowLabel": "account-drawer-module-scss-module__R3H9Uq__panelRowLabel",
  "panelRowLabelText": "account-drawer-module-scss-module__R3H9Uq__panelRowLabelText",
  "panelRowValue": "account-drawer-module-scss-module__R3H9Uq__panelRowValue",
  "pulse": "account-drawer-module-scss-module__R3H9Uq__pulse",
  "resetLink": "account-drawer-module-scss-module__R3H9Uq__resetLink",
  "sections": "account-drawer-module-scss-module__R3H9Uq__sections",
  "skeletonIcon": "account-drawer-module-scss-module__R3H9Uq__skeletonIcon",
  "skeletonLine": "account-drawer-module-scss-module__R3H9Uq__skeletonLine",
  "skeletonRow": "account-drawer-module-scss-module__R3H9Uq__skeletonRow",
});
